import AutenticacaoService from '@/app/services/Simulador/autenticacao.service'

/**
 * Store to handle the system jwt token
 */
const SystemJwtTokenModule = {
    state: {
        token: null
    },
    getters: {
        getSystemJwtToken(state) {
            if (state.token == null || state.token === undefined) { // não possui um token sistemico
                return { token: null, loginExpirado: true, mensagem: "A página solicitada está disponível apenas para usuários registrados. Faça o login para continuar." };
            }

            var dataExpiracaoToken = new Date(Date.parse(state.token.expiracao));
            var dataAtual = new Date();

            if (state.token.expiracao == null || dataExpiracaoToken <= dataAtual) { // Token expirou desde a última utilização
                state.token = null;
                return { token: null, loginExpirado: true, mensagem: "O sistema ficou muito tempo ocioso e a sessão expirou. Faça login novamente para continuar." };
            }
            
            return { token: state.token.token, loginExpirado: false, mensagem: null };
        }
    },
    mutations: {
        setSystemJwtToken(state, token) {
            state.token = token;
        }
    },
    actions: {
        async authAppUser() {
            return new Promise((resolve) => {
                AutenticacaoService.autenticar(process.env.VUE_APP_SYS_USER, process.env.VUE_APP_SYS_PASS).then((resultado) => {
                    resolve(resultado);
                })
            })
        }
    }
}

export default SystemJwtTokenModule;